(()=>{
'use strict';
const BUDGETS=['Under $30','$30–45','$45–60','$60–100','No budget limit'];
function budgetOK(price,b){const r=Math.round(price);if(b==='Under $30')return r<=30;if(b==='$30–45')return r>=30&&r<=45;if(b==='$45–60')return r>=45&&r<=60;if(b==='$60–100')return r>=60&&r<=100;return true}
function getPrice(card){const t=card.querySelector('.ezsf__buy span')?.textContent||'';const m=t.replace(/,/g,'').match(/\d+(?:\.\d+)?/);return m?Number(m[0]):NaN}
function getPriceLabel(card){return card.querySelector('.ezsf__buy span')?.textContent?.trim()||''}
function isSpanish(root){return root.querySelector('[data-lang="es"]')?.classList.contains('is-active')}
function emphasizeConversion(root){
  const results=root.querySelector('[data-screen="results"]');
  if(!results)return;
  const es=isSpanish(root);
  const label=es?'AGREGAR AL CARRITO — 10% OFF':'ADD TO CART — GET 10% OFF';
  const promoText=es?'🎁 10% OFF con EZENZIAUSA10':'🎁 10% OFF with EZENZIAUSA10';
  results.querySelectorAll('.ezsf__result').forEach(card=>{
    const btn=card.querySelector('[data-add]');
    if(btn){
      if(btn.textContent.trim()!==label)btn.textContent=label;
      btn.style.fontWeight='800';
      let promo=card.querySelector('[data-ezsf-card-offer]');
      if(!promo){
        promo=document.createElement('div');
        promo.dataset.ezsfCardOffer='true';
        promo.style.cssText='margin:10px 0 0;padding:9px 11px;border-radius:10px;background:linear-gradient(135deg,#eef9ff,#f7f0ff,#fff0fa);font-size:12px;font-weight:800;text-align:center;border:1px solid rgba(112,78,232,.14)';
        btn.insertAdjacentElement('beforebegin',promo);
      }
      if(promo.textContent!==promoText)promo.textContent=promoText;
    }
  });
}
function fallbackBlock(root,results,card,budget){
  const es=isSpanish(root);
  results.querySelector('.ezsf__gift')?.remove();
  results.querySelectorAll('.ezsf__hint').forEach(x=>x.remove());
  const h=results.querySelector('h2');
  if(h){const p=document.createElement('p');p.className='ezsf__hint';p.textContent=es?`No encontramos coincidencias cercanas dentro de tu presupuesto de ${budget}.`:`No close matches found within your ${budget} budget.`;h.insertAdjacentElement('afterend',p)}
  const block=document.createElement('div');block.dataset.ezsfBudgetFallbackBlock='true';block.className='ezsf__budget-fallback';block.style.margin='26px 0 14px';
  const title=document.createElement('h3');title.style.margin='0 0 6px';title.textContent=es?'También te puede interesar':'You may also like';
  const desc=document.createElement('p');desc.className='ezsf__hint';desc.style.margin='0 0 8px';desc.textContent=es?'Este es el match más cercano disponible, pero está fuera del presupuesto elegido.':'This is the closest available match, but it is outside your selected budget.';
  const badge=document.createElement('p');badge.className='ezsf__hint';badge.style.margin='0';badge.style.fontWeight='600';const price=getPriceLabel(card);badge.textContent=(es?'Fuera de presupuesto':'Outside budget')+(price?` · ${price}`:'');
  const offer=document.createElement('div');offer.dataset.ezsfFallbackOffer='true';offer.style.cssText='margin:14px 0 0;padding:14px;border-radius:14px;background:linear-gradient(135deg,#eef9ff,#f7f0ff,#fff0fa);text-align:center;border:1px solid rgba(112,78,232,.2)';
  const offerTitle=document.createElement('strong');offerTitle.textContent=es?'🎁 10% OFF EN TU MATCH':'🎁 10% OFF YOUR MATCH';
  const offerCopy=document.createElement('p');offerCopy.style.cssText='margin:6px 0 10px;font-size:12px';offerCopy.textContent=es?'Agrégalo al carrito y te llevamos al carrito con el código aplicado.':'Add it to cart and we’ll take you to your cart with the discount code applied.';
  const code=document.createElement('span');code.className='ezsf__code';code.textContent='EZENZIAUSA10';
  offer.append(offerTitle,offerCopy,code);
  block.append(title,desc,badge,offer);card.insertAdjacentElement('beforebegin',block);
  emphasizeConversion(root);
}
function enforce(root){
  const results=root.querySelector('[data-screen="results"]');
  if(!results||!results.classList.contains('is-active'))return;
  emphasizeConversion(root);
  if(results.querySelector('[data-ezsf-budget-fallback-block]'))return;
  const budget=root.dataset.ezsfSimilarBudget;
  if(!budget||budget==='No budget limit')return;
  const cards=[...results.querySelectorAll('.ezsf__result')];
  if(!cards.length)return;
  const inBudget=[],overBudget=[];
  cards.forEach(card=>{const price=getPrice(card);if(!Number.isFinite(price))return;(budgetOK(price,budget)?inBudget:overBudget).push(card)});
  if(inBudget.length){overBudget.forEach(card=>card.remove());return}
  if(overBudget.length){const fallback=overBudget[0];overBudget.slice(1).forEach(card=>card.remove());fallbackBlock(root,results,fallback,budget)}
}
document.addEventListener('click',e=>{
  const b=e.target.closest?.('[data-sv]');
  if(b&&BUDGETS.includes(b.dataset.sv)){
    const root=b.closest('[data-ezsf-root]');
    if(root&&b.closest('[data-screen="similar"]'))root.dataset.ezsfSimilarBudget=b.dataset.sv;
  }
  const lang=e.target.closest?.('[data-lang]');
  if(lang){const root=lang.closest('[data-ezsf-root]');if(root)setTimeout(()=>enforce(root),0)}
},true);
document.querySelectorAll('[data-ezsf-root]').forEach(root=>{
  const results=root.querySelector('[data-screen="results"]');
  if(!results)return;
  new MutationObserver(()=>queueMicrotask(()=>enforce(root))).observe(results,{childList:true,subtree:true});
  document.addEventListener('click',()=>queueMicrotask(()=>enforce(root)),true);
});
})();